import React from 'react';
import { styled } from "../../stitches.config"


interface LiveBadgeProps {
    live: boolean;
}

const LiveBadge: React.FC<LiveBadgeProps> = ({
    live = true,
}) => {
    return (
        <StyledLiveBadge live={live}>
            {live ? (<span>Relacja live</span>) : (<span>Relacja zakończona</span>)}
        </StyledLiveBadge>
    );
};

const StyledLiveBadge = styled('div', {
    width: "max-content",
    fontFamily: "HK Grotesk",
    fontStyle: "normal",
    fontWeight: "$6",
    fontSize: "16px",
    lineHeight: "24px",
    color: "$grayscale0Fixed",
    variants: {
        live: {
            true: {
                '&:before': {
                    content: "",
                    height: "12px",
                    width: "12px",
                    borderRadius: "12px",
                    display: "inline-block",
                    backgroundColor: "$aszdziennikPrimary",
                    marginRight: "6px",
                }
            }
        }
    }

})

export default LiveBadge